import { render } from "./PlanetsOrder.vue?vue&type=template&id=ed29c3e4&scoped=true"
import script from "./PlanetsOrder.vue?vue&type=script&lang=js"
export * from "./PlanetsOrder.vue?vue&type=script&lang=js"

import "./PlanetsOrder.vue?vue&type=style&index=0&id=ed29c3e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed29c3e4"]])

export default __exports__